import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { post } from '../../../Services/api';

const SavePaymentMethodForm = ({ customer_id, default_payment_method, setDefault_payment_method, only_payment_method }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const confirmSetup = await stripe.confirmSetup({
            //`Elements` instance that was used to create the Payment Element
            elements,
            redirect: "if_required"
        })

        try {
            const payment_method = await post("/api/billing/stripe/add-payment-method", {
                id: confirmSetup.setupIntent.payment_method,
                default_payment_method: default_payment_method,
                customer_id: customer_id
            })

            window.location.reload();
        } catch (error) {
            window.location.reload();
        }
    };


    const ColorButton = styled(Button)(({ theme }) => ({
        color: 'white',
        height: '45px',
        width: '250px',
        fontSize: '15px',
        marginTop: '20px',
        borderRadius: '8px',
        backgroundColor: '#259556',
        '&:hover': {
            backgroundColor: '#247e4b',
        },
    }));

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />

            <div className='flex gap_12 align_center'>
                <Checkbox onChange={(e) => setDefault_payment_method(e.target.checked)}
                    defaultChecked={only_payment_method} disabled={only_payment_method}
                    type="checkbox" />
                <p className='gray_scale_2'>Set as default</p>
            </div>

            <button type='submit' disabled={!stripe} className='checkout_form_pay cursor_pointer font_size_16'>Submit</button>

            {/* Show error message to your customers */}
            {errorMessage && <div>{errorMessage}</div>}
        </form>
    )
};

export default SavePaymentMethodForm;